<template>
  <TemplateBasic cloud instagram :tags="tags">
    <template v-slot:cloud>
      <Carousel :scrollPerPage="false" :perPage="itemsToShow" :navigationEnabled="true" :paginationEnabled="false"
        :loop="true" :autoplay="env !== 'dev'" :autoplayTimeout="3500" :speed="1500" :easing="'ease-out'"
        navigationNextLabel="<i class='fa fa-chevron-right'></i>"
        navigationPrevLabel="<i class='fa fa-chevron-left'></i>" :key="key">
        <Slide class="carousel" v-for="(slide, slideIndex) in slides" :key="slideIndex">
          <img width="100%" :src="slide.src" :alt="slide.name" />
          <div class="carousel__hover">
            <div class="carousel__content">
              <p class="carousel__title">{{ slide.name }}</p>

              <router-link :to="slide.link" tag="a" class="btn btn-border-white">
                Personnaliser
              </router-link>
            </div>
          </div>
        </Slide>
      </Carousel>
    </template>

    <template v-slot:body>
      <WidddiProductList :articles="articles" />

      <section class="wrap col-big-vspace tleft-child">
        <p class="sub-title tblack bold col-vbspace">Qui sommes-nous ?</p>

        <p class="col-vbspace">
          Hello, <strong>moi c'est Hélène</strong>, j'ai 35 ans et je vis à Lille. <br />
          Je suis graphiste de formation et je suis tombée dans le monde de <strong>l’impression 3D</strong> lorsque
          j’ai rencontré mon amoureux fin 2017. Widddi a vu le jour en 2019 et j’en ai rapidement fait mon activité
          principale à temps plein.
        </p>

        <p class="col-vbspace">
          Aujourd’hui, grâce à la <strong>modélisation et l’impression 3D</strong>, je crée des outils qui t’aident dans
          tes <strong>projets de modelage</strong>, poterie, argile, céramique, pâte polymère,…<br />
          Je te propose, notamment, un grand choix de <strong>tampons alphabet</strong> pour agrémenter tes créations
          artisanales de jolis mots ou bien de phrases drôles ou percutantes. Les tampons alphabet Widddi ont la
          particularité d’être ultra <strong>organisés et polyvalents</strong>, pour un usage et un rangement facile et
          optimal.<br /> Je crée et fabrique également des <strong>emporte-pièces</strong> de 1,5cm à 23cm de large. Tu
          as aussi la possibilité de me commander des <strong>emporte-pièces</strong> sur mesure, à partir de tes
          propres croquis.
        </p>

        <p class="col-vbspace">
          Mes produits sont fabriqués via <strong>impression 3D</strong>. Je n’utilise que du <strong>PLA</strong> ou
          Polylactic acid, c’est une matière <strong>plastique végétale</strong> issue de l’amidon de maïs (il n’est
          donc pas issu du pétrole contrairement au plastique traditionnel) et est <strong>biodégradable en compostage
            industriel</strong>.
        </p>

        <p class="col-vbspace">
          En ce qui concerne <strong>les expéditions</strong>, j'expédie principalement en <strong>Europe</strong> via
          Mondial Relay : France métropolitaine, Belgique, Luxembourg, Pays-Bas, Espagne, Portugal, Italie, Pologne,
          Allemagne, Autriche. La livraison en point Mondial Relay vers la France est offerte dès 70€ d'achats.
          <router-link to="/faq#q9">Voir les tarifs d'expédition</router-link>. L’expédition via Mondial Relay est
          l’option la plus <strong>rapide et efficace</strong> par rapport à mes habitudes d’expédition.
          Un locker à proximité de chez moi me permet de poster les colis facilement et rapidement sans contrainte
          d’horaire.
        </p>

        <p class="col-vbspace">
          Si besoin, je propose également la <strong>livraison à domicile</strong> en France métropolitaine via La Poste
          et en Belgique via Bpost.
        </p>

        <p class="col-vbspace">
          Si tu souhaites te faire livrer dans un pays qui n’est pas répertorié dans la liste ci-dessus, tu peux me
          contacter pour essayer de trouver une solution ensemble.
        </p>

        <p class="col-vbspace">
          Pour toute autre question, n’hésite pas à me contacter via mon
          <router-link :to="{ name: 'contact' }">formulaire de contact</router-link> ou via Instagram @‌widddi3d!
        </p>

        <WidddiSocials />
      </section>

      <WidddiInstagram :count="6" :tags="tags" containerClass="row"></WidddiInstagram>
    </template>
  </TemplateBasic>
</template>

<script>
import { mapGetters } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';
import { TemplateBasic, WidddiProductList } from '@/components/template';
import { WidddiSocials } from '@/components/template/Elements';
import { WidddiInstagram } from '@/components/external';

export default {
  created() {
    window.addEventListener('resize', this.getWindowWidth);
    this.getWindowWidth();
  },

  mounted() {
    if (localStorage.getItem('cvd-20-1') !== null) {
      localStorage.removeItem('cvd-20-1');
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
  },

  data() {
    return {
      tags: ['widddi3d'],
      key: 0,
      itemsToShow: 3,
      slides: [
        {
          src: require('../../public/img/materiel-creatif/accessoires/pince-tampons-alphabet.jpg'),
          name: 'Pince à lettres',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/accessoires/pince-a-lettres',
        },
        {
          src: require('../../public/img/biscuits/ep-oiseau.jpg'),
          name: 'Emporte-pièce Oiseau',
          link:
            '/produit/materiel-creatif/emporte-piece/oiseau',
        },
        {
          src: require('../../public/img/materiel-creatif/maxi-tampons/vignette-maxitampons.jpg'),
          name: 'Sets maxi tampon alphabet',
          link: '/produit/materiel-creatif/set-tampon-alphabet/set-maxi-tampon-alphabet',
        },
        {
          src: require('../../public/img/biscuits/ep-tartine.jpg'),
          name: 'Emporte-pièce Tartine',
          link:
            '/produit/materiel-creatif/emporte-piece/tartine',
        },
      ],
      articles: [
        {
          src: require('../../public/img/materiel-creatif/vignette-sets-tampons-alphabet.jpg'),
          variant: 'Sets tampon alphabet',
          link: '/produit/materiel-creatif/set-tampon-alphabet',
        },
        {
          src: require('../../public/img/emporte-piece/emporte-pieces-widddi.jpg'),
          variant: 'Emporte-pièces',
          link: '/produit/materiel-creatif/emporte-piece',
        },
        {
          src: require('../../public/img/biscuits/ep-alphabet.jpg'),
          name: 'Emporte-pièces',
          variant: 'Alphabet & Chiffres',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet',
        },
        {
          src: require('../../public/img/biscuits/alphabet-dosis.jpg'),
          name: 'Emporte-pièces',
          variant: 'Alphabet & Chiffres Dosis',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis',
        },
        {
          src: require('../../public/img/emporte-piece/emporte-pieces-sur-mesure.jpg'),
          variant: 'Emporte-pièces sur mesure',
          link: '/produit/materiel-creatif/emporte-piece-sur-mesure',
        },
        {
          src: require('../../public/img/materiel-creatif/tourninouneur/tourninouneur-widddi.jpg'),
          variant: 'Outils',
          link: '/produit/materiel-creatif/outils/tourninouneur',
        },
        {
          src: require('../../public/img/gift/carte-cadeau-widddi.jpg'),
          variant: 'Cartes cadeaux',
          link: '/produit/cadeaux/cartes-cadeaux',
        },
      ],
    };
  },

  components: {
    TemplateBasic,
    Carousel,
    Slide,
    WidddiInstagram,
    WidddiSocials,
    WidddiProductList,
  },

  computed: {
    ...mapGetters({
      cart: 'shop/cart',
      auth: 'app/auth',
      env: 'app/env',
      baseurl: 'app/baseurl',
      priceCadre: 'shop/priceCadre',
    }),
  },

  methods: {
    getWindowWidth() {
      let toShow = this.itemsToShow;
      if (window.innerWidth < 410) {
        toShow = 1;
      } else if (window.innerWidth < 768) {
        toShow = 2;
      } else if (window.innerWidth < 1100) {
        toShow = 3;
      } else {
        toShow = 4;
      }

      if (toShow !== this.itemsToShow) {
        this.itemsToShow = toShow;
        this.$nextTick(() => {
          this.key += 1;
        });
      }
    },
  },
};
</script>
